<div class="hx-pagination-wrap" [class.hx-pagination--disabled]="disabled()">
  <div class="hx-pagination" role="group" [attr.aria-label]="'Pagination controls'">
    <div class="pagination-leading">
      <!-- Rows per page section -->
      <div class="pagination-section rows-per-page" aria-label="Rows per page selection">
        <label [for]="'rows-per-page-label'" id="rows-per-page-label-text">
          {{ rowsPerPageLabel() }}
        </label>
        <hx-dropdown
          [attr.id]="'rows-per-page-label'"
          [attr.aria-labelledby]="'rows-per-page-label-text'"
          panelClass="hx-pagination__page-size-panel"
          [ngModel]="pageSize()"
          [options]="pageSizeOptions()"
          (ngModelChange)="onPageSizeChange($event)"
          [disabled]="disabled()"
          class="rows-per-page-select" />
      </div>

      @if (showTotalRecordCount()) {
        <div class="pagination-section total-record-count" aria-live="polite">
          <span>{{ totalRecordCountLabel() }}</span>
          <hx-badge
            type="text"
            variant="fill"
            context="brand"
            [label]="'' + totalRecordCount()"
            [ariaLabel]="totalRecordCountLabel() + ' ' + totalRecordCount()" />
        </div>
      }
    </div>

    <!-- Page navigation section -->
    <nav class="pagination-section page-navigation" aria-label="Page navigation">
      <!-- Previous button -->
      <button
        hxIconButton
        type="button"
        class="page-navigation-button"
        svgIcon="ccs-chevron-left"
        context="neutral"
        variant="outline"
        size="sm"
        [disabled]="!hasPreviousPage() || disabled()"
        (click)="previousPage()"
        [attr.aria-label]="'Previous page'"></button>

      <!-- Page numbers -->
      <div class="page-numbers">
        @for (btn of pageNumberButtons(); track btn.pageNumber) {
          @if (btn.isEllipsis) {
            <!-- Ellipsis button (non-clickable) -->
            <button hxButton variant="ghost" size="sm" [attr.aria-label]="null" class="page-button ellipsis-button">
              {{ btn.displayText }}
            </button>
          } @else {
            <!-- Page number button (clickable) -->
            <button
              hxButton
              variant="ghost"
              size="sm"
              [disabled]="disabled()"
              (click)="goToPage(btn.pageNumber)"
              [attr.aria-label]="'Go to page ' + btn.pageNumber"
              [attr.aria-current]="btn.isCurrentPage ? 'page' : null"
              [class.current-page]="btn.isCurrentPage"
              class="page-button">
              {{ btn.displayText }}
            </button>
          }
        }
      </div>

      <!-- Next button -->
      <button
        hxIconButton
        class="page-navigation-button"
        svgIcon="ccs-chevron-right"
        variant="outline"
        size="sm"
        context="neutral"
        [disabled]="!hasNextPage() || disabled()"
        (click)="nextPage()"
        [attr.aria-label]="'Next page'"></button>
    </nav>

    <!-- Go to page section -->
    @if (showGotoPage()) {
      <div class="pagination-section go-to-page" aria-label="Go to page navigation">
        <hx-input
          type="number"
          [label]="gotoPageLabel()"
          [orientation]="'horizontal'"
          [attr.id]="'goto-page-input'"
          [min]="1"
          [max]="totalPages()"
          [value]="gotoPageValue()"
          (input)="onGotoPageChange($event)"
          (keydown.enter)="onGotoPageSubmit($event)"
          [attr.aria-labelledby]="'goto-page-label'"
          [attr.aria-invalid]="!!gotoPageError()"
          [disabled]="disabled()"
          [hideErrorMessage]="true"
          size="sm"
          class="goto-page-input" />
      </div>
    }
  </div>
  @if (gotoPageError()) {
    <span role="alert" aria-live="polite" class="error-message">
      {{ gotoPageError() }}
    </span>
  }
</div>
